<template>
  <div style="margin-top: 113px">
    <v-container>
      <v-card>
        <v-card-title>Admin Users ({{ admins.length }} admins)</v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr class="general-background">
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>First Name</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>Last name</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>Login</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>Perimeter(s)</b>
                  </th>
                  <th
                    v-if="hasRoleSuperAdmin()"
                    class="text-left col-elem border-elem"
                    style="width:15%"
                  >
                    <b>Action</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="admin in admins" v-bind:key="admin.id">
                  <th class="text-left border-elem pa-0 pl-1">
                    {{ admin.firstName }}
                  </th>
                  <th class="text-left border-elem pa-0 pl-1">
                    {{ admin.lastName }}
                  </th>
                  <th class="text-left border-elem pa-0 pl-1">
                    {{ admin.login }}
                  </th>
                  <th class="text-left border-elem pa-0 pl-1">
                    {{ admin.adminPerimeter }}
                  </th>
                  <th
                    v-if="hasRoleSuperAdmin()"
                    class="text-left border-elem pa-0 pl-1"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          text
                          icon
                          v-on="on"
                          :to="'/updateAdminUser/' + admin.id"
                        >
                          <v-icon class="mr-2">
                            mdi-lead-pencil
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Update Admin</span>
                    </v-tooltip>
                  </th>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <v-card v-if="hasRoleSuperAdmin()">
        <v-card-title>Add Admin User</v-card-title>
        <v-card-text>
          <v-form>
            <v-autocomplete
              v-model="user"
              :items="itemsForUser"
              :loading="isLoadingForUser"
              :search-input.sync="searchForUser"
              color="white"
              hide-no-data
              hide-selected
              item-text="Description"
              item-value="SLM"
              label="User"
              placeholder="Start typing to search"
              prepend-icon="mdi-database-search"
              return-object
            >
            </v-autocomplete>
            <v-simple-table>
              <tbody v-if="user">
                <tr>
                  <th>
                    <v-btn
                      depressed
                      small
                      color="primary"
                      @click="clearUser()"
                      class="ma-4"
                    >
                      Reset User
                    </v-btn>
                    <v-btn
                      depressed
                      small
                      color="success"
                      class="ma-4"
                      @click="AddAdminUser(entriesForUser[0].id)"
                    >
                      Add User
                    </v-btn>
                  </th>
                </tr>
              </tbody>
            </v-simple-table>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<style></style>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Admin",
  data() {
    return {
      admins: [],
      listUsers: [],
      user: null,
      isLoadingForUser: false,
      searchForUser: null,
      entriesForUser: [],
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
      userRoles: "auth/userRoles",
      perimeterAdmin: "auth/perimeterAdmin",
    }),
    itemsForUser() {
      return this.listUsers.map(
        (element) => element.firstName + " " + element.lastName
      );
    },
  },
  watch: {
    searchForUser(val) {
      if (this.isLoadingForUser) return;
      this.isLoadingForUser = true;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH + "api/usersWithName?name=" + val,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.listUsers = res.data;
          this.countForUser = res.data.length;
          let selectedUser = "";
          for (var i = 0; i < this.countForUser; i++) {
            selectedUser =
              this.listUsers[i].firstName + " " + this.listUsers[i].lastName;
            if (selectedUser == this.searchForUser) {
              this.entriesForUser[0] = this.listUsers[i];
            }
          }
        })
        .finally(() => (this.isLoadingForUser = false));
    },
  },
  mounted: function() {
    this.loadAdminUsers();
  },
  methods: {
    loadAdminUsers: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/usersadmin/", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200") {
            return response.json();
          }
        })
        .then((json) => {
          if (json) {
            this.admins = json.data;
          }
        });
    },
    clearUser() {
      this.user = null;
      this.entriesForUser = [];
    },
    AddAdminUser: function(item) {
      this.$router.push("AddAdminUser/" + item);
    },
    hasRoleSuperAdmin: function() {
      if (this.userRoles && this.perimeterAdmin == "all") {
        var userHasRole = false;
        this.userRoles.forEach(function(currentRole) {
          if (currentRole === "ROLE_ADMIN") {
            userHasRole = true;
          }
        });
        return userHasRole;
      }
    },
  },
};
</script>
